export const DOWNLOADING_LABELS = ['Processing', 'Taking a bit', 'Almost there'];

export const DEFAULT_TEMPLATE_TAG = 'Brand Templates';

export const ALL_TEMPLATES_LIMIT = 500;
